export default "https://cdn-static.gokick.com/assets/a067049b7600101c8dd9c58c97ab0ac81c37d227/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";